import React from 'react';
import {PropTypes} from "prop-types";
import {connect} from 'react-redux';
import Paper from "@material-ui/core/Paper/Paper";
import {styles} from "./MatrixCell"
import {buildMatrix} from "../../reducers/practiceChanges";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

class MatrixCellPriority extends React.Component {

    constructor(props) {
        super(props);
    }


    static getBackgroundColor(priority) {
        return ["lightgreen", "yellow", "red"][priority];
    }


    render() {
        const highlight = this.props.highlight;
        return (<Paper style={{...styles.innerWrappers, border:"solid " + highlight.size + " " + highlight.color, backgroundColor: MatrixCellPriority.getBackgroundColor(this.props.priority)}}>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"center", height:"100%"}}>
                            {this.props.cell.text}
                    </div>
        </Paper>)
    }
}

MatrixCellPriority.propTypes = {
    row: PropTypes.number.isRequired,
    col: PropTypes.number.isRequired,
    priority: PropTypes.number,
    matrixId: PropTypes.number.isRequired,
    cell: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
    let matrix;
    if(ownProps.matrixId !== undefined && ownProps.matrixId !== null){
        matrix = state.practiceChanges.filter(v => v.id === ownProps.matrixId)[0].matrixData;
    }else{
        matrix = buildMatrix()
    }
    let entry = matrix.entries[ownProps.row][ownProps.col];
    return {
        priority: entry.priority,
    }
};

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MatrixCellPriority);